<script setup lang="ts">
const props = defineProps({
  selected: {
    type: Number,
  },
  items: {
    type: Number,
    required: true,
  },
  currentPage: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(["click"]);

function clickEmit(nb: number) {
  emit("click", nb);
}

const pagesToShow = computed(() => {
  const pages = [];
  const totalItems = props.items;
  const currentPage = props.currentPage + 1;

  // Calculer les pages de début et de fin
  let startPage = 1;
  let endPage = totalItems;

  // Toujours montrer les trois premières et les trois dernières pages sans "..."
  if (currentPage <= 3) {
    // Si la page courante est parmi les trois premières
    startPage = 1;
    endPage = Math.min(3, totalItems); // Ne dépasser pas le nombre total de pages
    if (totalItems > 3) {
      pages.push(...Array.from({ length: endPage }, (_, i) => i + 1));
      pages.push("...");
      pages.push(totalItems);
    } else {
      pages.push(...Array.from({ length: totalItems }, (_, i) => i + 1));
    }
  } else if (currentPage >= totalItems - 2) {
    // Si la page courante est parmi les trois dernières
    startPage = Math.max(1, totalItems - 2);
    endPage = totalItems;
    pages.push(1);
    pages.push("...");
    pages.push(...Array.from({ length: 3 }, (_, i) => totalItems - 2 + i));
  } else {
    // Cas général pour toutes les autres pages
    pages.push(1);
    if (currentPage > 2) pages.push("...");
    pages.push(currentPage);
    if (currentPage < totalItems - 1) pages.push("...");
    pages.push(totalItems);
  }

  return pages;
});
</script>

<template>
  <div class="toggle_containers body_regular">
    <div class="toggle_button pagination_slot hover" @click="clickEmit(currentPage - 1)">
      <img class="pagination_img" src="/icons/generic/arrow_next.svg" style="transform: rotate(180deg)" alt="" />
    </div>
    <button
      v-for="(item, index) in pagesToShow"
      :key="index"
      class="toggle_button"
      name="0"
      :class="{ hover: item !== '...' }"
      :data-toggled="item === currentPage + 1"
      @click="item !== '...' ? clickEmit((item as number) - 1) : null"
    >
      <div v-if="props.items">{{ item }}</div>
    </button>
    <div class="toggle_button pagination_slot hover" @click="clickEmit(currentPage + 1)">
      <img class="pagination_img" src="/icons/generic/arrow_next.svg" alt="" />
    </div>
  </div>
</template>

<style scoped>
.toggle_containers {
  @apply flex flex-row;
  border: solid 1px var(--grey-lightest);
  border-radius: 12px;
  overflow: hidden;
}

.toggle_button {
  @apply flex items-center justify-center;
  box-sizing: border-box;
  height: 24px;
  min-width: 36px;
  padding-left: 4px;
  padding-right: 4px;
  color: var(--text-secondary-color);

  &[data-toggled="true"] {
    background: var(--grey-light);
    color: var(--text-main-color);
  }

  &:not(:first-child) {
    border-left: solid 1px var(--grey-lightest);
  }
}

.hover:hover {
  background: var(--grey-light);
  color: var(--black-dark);
}
</style>
